import {
  ME_URL,
  ME_URL_V2,
  LOGIN_URL,
  LOGOUT_URL,
  REGISTER_URL,
  PASSWORD_RESET_URL,
  PASSWORD_RESET_LOGIN_URL,
  PASSWORD_UPDATE_URL,
  USERNAME_UPDATE_URL,
  SHOW_MFA_REGISTRATION_QR_URL,
  UPDATE_MFA_INFO_URL,
  VERIFY_2FA_CODE_URL,
  UPDATE_ME_URL,
  GET_STORY_URL
} from 'shared/utils/Constants';

import {
  get,
  post,
  put,
  destroy
} from 'shared/services/ApiService';

export const me = async () => {
  return await get(ME_URL);
}

export const login = async (email, password) => {
  let params = {
    email,
    password
  }

  return await post(LOGIN_URL, params);
}

export const logout = async () => {
  return await get(LOGOUT_URL);
}

export const register = async (email, password) => {
  let params = {
    email,
    password
  }

  return await post(REGISTER_URL, params);
}

export const requestPasswordReset = async params => {
  return await post(PASSWORD_RESET_URL, params);
}

export const passwordResetLogin = async params => {
  return await post(PASSWORD_RESET_LOGIN_URL, params);
}

export const updatePassword = async params => {
  return await put(PASSWORD_UPDATE_URL, params);
}

export const updateUserName = async params => {
  return await put(USERNAME_UPDATE_URL(params.id), params);
}

export const updateMFAInfo = async params => {
  return await put(UPDATE_MFA_INFO_URL(params.id), params);
}

export const getMFARegistrationQR = async () => {
  return await get(SHOW_MFA_REGISTRATION_QR_URL());
}

export const verify2FACode = async params => {
  return await post(VERIFY_2FA_CODE_URL(), params);
}

export const updateMe = async params => {
  return await put(UPDATE_ME_URL(), params);
}

export const setLocale = async locale => {
  return await put(ME_URL_V2, { locale });
}

export const getAccessCode = async () => {
  let stories = await get(GET_STORY_URL);

  if (stories.length == 0) {
    throw 'no story';
  }

  var story = stories.find((x) => { return x.access_code !== "" });

  const accessCode = story ? story.access_code : '';
  return accessCode;
}
